// packages
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// assets
import { NavLink } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";

export default function SliderWithText({
  slider,
  href,
  title,
  description,
  reverse = false,
}) {
  return (
    <div
      className={`${reverse && "md:flex-row-reverse"} flex gap-20 max-md:flex-col md:items-center`}
    >
      <div className="md:w-1/2">
        <h2 className="s-h1 mb-5 block text-center max-md:mt-12 md:hidden">
          <NavLink
            className="text-t-gray"
            to={href}
          >
            {title}
          </NavLink>
        </h2>
        <Swiper
          modules={[Pagination]}
          loop={true}
          slidesPerView={1}
          spaceBetween={0}
          speed={1500}
          pagination={{
            enabled: true,
            clickable: true,
            dynamicBullets: true,
          }}
          style={{
            "--swiper-pagination-color": "#404040",
            "--swiper-pagination-bullet-inactive-color": "#c6a58e",
            "--swiper-pagination-bullet-size": "1rem",
            "--swiper-pagination-bullet-border-radius": "0",
          }}
        >
          {slider.map((item, idx) => (
            <SwiperSlide
              key={idx}
              className="border border-black/5"
            >
              <NavLink
                className="flex items-center justify-center text-t-gray sm:p-28"
                to={href}
              >
                <img
                  className="max-h-[70%] max-w-[70%]"
                  src={item.image.src}
                  alt={title}
                />
              </NavLink>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="text-center md:w-1/2 md:space-y-5">
        <h2 className="s-h1 hidden md:block">
          <NavLink
            className="text-t-gray"
            to={href}
          >
            {title}
          </NavLink>
        </h2>
        <p className="s-text">{description}</p>
      </div>
    </div>
  );
}
